import { Icon } from "@iconify/react";
import "./SecondaryNav.css";

const SecondaryNav = ({ activeTab, onScanClick, onLeadsClick, onTeamClick, isDesktop, showTeam = true }) => {
  if (!isDesktop) {
    return null;
  }

  return (
    <nav className="secondary-nav">
      <button
        className={`secondary-nav__item ${activeTab === "scan" ? "secondary-nav__item--active" : ""}`}
        onClick={onScanClick}
      >
        <Icon icon="lucide:scan-line" width="18" height="18" />
        Scan Leads
      </button>
      <button
        className={`secondary-nav__item ${activeTab === "leads" ? "secondary-nav__item--active" : ""}`}
        onClick={onLeadsClick}
      >
        <Icon icon="grommet-icons:group" width="18" height="18" />
        View Leads
      </button>
      {showTeam && (
        <button
          className={`secondary-nav__item ${activeTab === "team" ? "secondary-nav__item--active" : ""}`}
          onClick={onTeamClick}
        >
          <Icon icon="lets-icons:group-share" width="18" height="18" />
          Team
        </button>
      )}
    </nav>
  );
};

export default SecondaryNav;

